import { ActionExecutionStatus } from '@ampsec/platform-client';

export const formatExecutionDate = (dateString: string | null | undefined): string => {
    if (!dateString) {
        return '—';
    }
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return '—';
    }
    return date.toLocaleString();
};

export const formatExecutionDuration = (ms: number | null | undefined): string => {
    if (ms === null || ms === undefined || Number.isNaN(ms)) {
        return '—';
    }
    const abs = Math.abs(ms);
    if (abs < 1000) {
        return `${ms} ms`;
    }
    return `${(ms / 1000).toFixed(2)} s`;
};

export const formatExecutionPayloadPreview = (value: unknown): string => {
    if (value === null || value === undefined) {
        return '—';
    }
    if (typeof value === 'string') {
        return value.length > 160 ? `${value.slice(0, 160)}…` : value;
    }
    try {
        const serialized = JSON.stringify(value);
        return serialized.length > 160 ? `${serialized.slice(0, 160)}…` : serialized;
    } catch {
        return '—';
    }
};

export const getExecutionStatusBadgeClass = (status: ActionExecutionStatus): string => {
    switch (status) {
        case ActionExecutionStatus.SUCCESS:
            return 'badge-success';
        case ActionExecutionStatus.ERROR:
            return 'badge-danger';
        case ActionExecutionStatus.PENDING:
            return 'badge-warning';
        case ActionExecutionStatus.RUNNING:
            return 'badge-info';
        default:
            return 'badge-secondary';
    }
};
